export default "__VITE_ASSET__CvZ_3H0b__"